import moment from 'moment';
import {
  Arr
} from '../Array.lib';
import Core from '../Core';
import globalErrorHandler from '../Error/globalErrorHandler.fun';
import noActionTaken from '../Global/noActionTaken.fun';
import {
  Obj
} from '../Object.lib';
import {
  COLLECTION__EMPLOYER_SOURCE_LISTS,
  COLLECTION__JOB_SOURCE_LISTS,
  createLoopbackRecord,
  readLoopbackRecord,
  updateLoopbackRecord
} from '../services/BE/loopback.api';
import {
  trim
} from '../String.lib';

/**
 * Adds accountIds to source list of a job or employer.
 * If source exists it will be updated, otherwise it will be created.
 * 
 * @param {Object} [options] - options object
 * @param {string} [options.employerId] - employerId that the accountIds should be added to
 * @param {string} [options.jobId] - jobId that the accountIds should be added to
 * @param {string[]} [options.accountIds] - array of accountIds to add to source list
 * @returns {Promise} - resolves if no error is thrown
 */
export default async function addAccountToSourceList({
  employerId = '',
  jobId = '',
  accountIds = [],
}) {
  try {

    if (!accountIds.length) { return noActionTaken(); }

    const KEY__COLLECTION = (
      employerId
        ? COLLECTION__EMPLOYER_SOURCE_LISTS
        : COLLECTION__JOB_SOURCE_LISTS
    );

    // Only one of employerId or jobId should be 
    // provided in following where clause
    const MODEL__WHERE = employerId ? { employerId } : { jobId };

    const existingSources = Arr(
      await readLoopbackRecord({
        collection: KEY__COLLECTION,
        where: MODEL__WHERE,
      })
    );

    const hashExistingSourcesByAccountId = {};
    const existingAccountIds = existingSources.map((source) => {
      hashExistingSourcesByAccountId[source.accountId] = source;
      return source.accountId;
    });

    Core.showLoader('Updating source list...');

    for (const accountId of accountIds) {
      const MODEL__RECORD = {
        ...MODEL__WHERE,
        accountId,
        who: trim(Obj(Core.getUser()).email),
        startDate: moment().toISOString(),
        endDate: null,
      };
      if (existingAccountIds.includes(accountId)) {
        await updateLoopbackRecord({
          collection: KEY__COLLECTION,
          id: hashExistingSourcesByAccountId[accountId].id,
          record: MODEL__RECORD
        });
      }
      else {
        await createLoopbackRecord({
          collection: KEY__COLLECTION,
          record: MODEL__RECORD
        });
      }
    }

    Core.showSuccess('Source list successfully updated.');

  }
  catch (error) {
    globalErrorHandler(error);
  }
}
